import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, NgModel } from '@angular/forms';
import { MancoOrderDetailsForm } from '../manco-form-types';
import { APIDeliveryAddress } from '../../manco-order-request';
import { MancoAddressOption } from '../new-manco-form.component';

const ISH_NIGHTSHIPPING_PREFIX = 'shipping-nt';
const ISH_PICK_UP_AT_COUNTER = 'pick-up-at-counter';

@Component({
  selector: 'app-new-manco-form-deliveryaddress',
  templateUrl: './new-manco-form-deliveryaddress.component.html',
  styleUrl: './new-manco-form-deliveryaddress.component.scss',
})
export class NewMancoFormDeliveryaddressComponent {
  @Input() shippingMethod!: string;
  @Input() form!: FormGroup<MancoOrderDetailsForm>;
  @Input() addressOptions: MancoAddressOption[] = [];

  @Output() addressSelectionChange = new EventEmitter<number>();

  @ViewChild('switchToDayShipping') switchToDayShipping!: NgModel;

  selectedAddressIndex: number = 0;

  get valid(): boolean {
    return !!this.form.get('deliveryAddress')?.valid;
  }

  get address(): APIDeliveryAddress {
    return {
      company: this.form.value.deliveryAddress?.company,
      firstName: this.form.value.deliveryAddress?.firstName,
      lastName: this.form.value.deliveryAddress?.lastName,
      telephoneNumber: this.form.value.deliveryAddress?.telephoneNumber,
      emailAddress: this.form.value.deliveryAddress?.email,
      address: this.form.value.deliveryAddress?.address,
      postalCode: this.form.value.deliveryAddress?.postalCode,
      city: this.form.value.deliveryAddress?.city,
      country: this.form.value.deliveryAddress?.country,
    } as APIDeliveryAddress;
  }

  onAddressPickerChange(event: Event): void {
    const raw = (event.target as HTMLSelectElement).value;
    const index = parseInt(raw, 10);
    if (Number.isNaN(index)) {
      return;
    }
    this.selectedAddressIndex = index;
    this.addressSelectionChange.emit(index);
  }

  isNightShippingMethod(): boolean {
    return this.shippingMethod.toLowerCase().startsWith(ISH_NIGHTSHIPPING_PREFIX);
  }

  isPickUpAtCounterShippingMethod(): boolean {
    return this.shippingMethod.toLowerCase() === ISH_PICK_UP_AT_COUNTER;
  }

  /**
   * A manco inherits the shipping method of the original order. Both nightshipping and pick-up-at-counter
   * can be undesirable for a manco (the customer is waiting, or does not want a second trip to the counter),
   * so the agent may downgrade them to regular day shipping. Day shipping itself has nothing to switch to.
   */
  canSwitchToDayShipping(): boolean {
    return this.isNightShippingMethod() || this.isPickUpAtCounterShippingMethod();
  }

  originalShippingMethodDescription(): string {
    return this.isNightShippingMethod()
      ? 'Dit was een order met nightshipping'
      : 'Dit was een order met afhalen bij de balie';
  }

  onSwitchToDayShippingChange(): void {
    const isChecked = this.form.get('deliveryAddress.switchToDayShipping')?.value;
    this.form.patchValue({
      ishShippingMethodID: isChecked ? 'shipping-standard-free' : this.shippingMethod,
    });
  }

  getFormControl(control: AbstractControl | null): FormControl {
    return control as FormControl;
  }
}
